import React from "react"
import OptimizedImage from "../../../utils/optimizedImage"
import { NavMenuItemWrapper } from "../styles/DesktopNavigation.styled"

const NavMenuItem = ({ title, description, icon, url, key }) => (
  <NavMenuItemWrapper className="nav-menu-item--wrapper" key={key}>
    <a
      className={`nav-menu-item--link ${!description ? "no-description" : ""}`}
      href={url || "#"}
      aria-label={title}
    >
      <div className="nav-menu-item--icon">
        <OptimizedImage
          src={icon?.file?.url}
          alt={icon?.title || title || "icon"}
          image={icon?.gatsbyImageData}
          className="icon-image"
        />
      </div>
      <div className="nav-menu-item--content">
        <span>{title}</span>
        <p>{description}</p>
      </div>
    </a>
  </NavMenuItemWrapper>
)

export default NavMenuItem
